import { wizardReducer } from './wizardReducer';
import { combineReducers } from 'redux';

export const Reducers = combineReducers({
  wizardState: wizardReducer,
});